import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import PropTypes from 'prop-types';

const RichTextEditor = ({ personalizedText, setPersonalizedText }) => {
  return (
    <>
      <ReactQuill
        value={personalizedText}
        onChange={setPersonalizedText}
        modules={{
          toolbar: [
            [{ header: '2' }],
            [{ size: [] }],
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            [{ align: [] }],
            [{ color: ['red', '#000'] }],
          ],
        }}
        formats={[
          'header',
          'font',
          'size',
          'bold',
          'italic',
          'underline',
          'list',
          'bullet',
          'indent',
          'align',
          'color',
        ]}
      />
    </>
  );
};

RichTextEditor.propTypes = {
  personalizedText: PropTypes.string.isRequired,
  setPersonalizedText: PropTypes.func.isRequired,
};
export default RichTextEditor;
